import * as Greenzine from "@coderehab/greenzine-react-deprecated";
import { PollModel } from "./poll";

export interface PollProvider extends Greenzine.PollProvider {}

export class AdminPollProvider extends Greenzine.DefaultPollProvider implements PollProvider {
  public model = PollModel;
}
